import z from 'zod';
import { collectPaymentFormSchema } from './collect-payment-form';

export const collectPaymentDataSchema = collectPaymentFormSchema.and(
  z.object({
    contractId: z.string(),
  }),
);

export type CollectPaymentData = z.infer<typeof collectPaymentDataSchema>;
